/**
 * Each rows specific data for table
 */
export const formatAsPercentage = (num: number | string): string => {
  const value = typeof num === "number" ? num : parseFloat(num || "0");
  return `${(value * 100).toFixed(0)}%`;
};
